"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * User profile converter.
 *
 * @author Radek Beran
 */


var UserProfileConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(UserProfileConverter, _DataObjectConverter_);

  function UserProfileConverter() {
    _classCallCheck(this, UserProfileConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserProfileConverter).apply(this, arguments));
  }

  return UserProfileConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.UserProfileConverter = UserProfileConverter;